var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-view account"},[_c('SettingsCard',{attrs:{"patient":_vm.patient}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }